/** @format */
import editModeTpl from './editMode.tpl.html';

export const editModeModule = 'sis-components.edit.editMode';

(function () {
    angular.module(editModeModule, ['sis-components.whitelayer']).directive('editMode', [
        '$rootScope',
        function ($rootScope) {
            return {
                restrict: 'E',
                template: editModeTpl,
                link: function ($scope) {
                    $scope.isEditMode = false;

                    $rootScope.$on('setEditMode', function (event, data) {
                        $scope.isEditMode = data === true || data === 'true';
                    });
                },
            };
        },
    ]);
})();
